import React from 'react';
import type { NamePath } from '@xbcb/ui-types';
import PgaDisclaimAiStatus from 'components/PgaDisclaimAiStatus';
import { useComplianceRecommendation } from 'libs/hooks';

export interface PgaDisclaimSectionProps {
  lineNamePath: NamePath;
  fullNamePath: NamePath;
  pgaFlag: string;
  agencyName: string;
}

// Renders the PGA Disclaim AI status banner for a single flag. The disclaim is
// now applied automatically by the backend (XbcbWorkOrderWorkflow PGA disclaim
// response handler), so the former accept/decline recommendation card is no
// longer shown; this surfaces the AI status only.
const PgaDisclaimSection: React.FC<PgaDisclaimSectionProps> = ({
  lineNamePath,
  fullNamePath,
  pgaFlag,
  agencyName,
}) => {
  const { status, details, isDisclaimed } = useComplianceRecommendation({
    lineNamePath,
    fullNamePath,
    pgaFlag,
  });

  return (
    <PgaDisclaimAiStatus
      status={status}
      agencyName={agencyName}
      isDisclaimed={isDisclaimed}
      rationale={details.reason}
    />
  );
};

export default PgaDisclaimSection;
